import React from "react";
import styles from "./Map.module.scss";

interface MapProps {
  url: string;
}

const Map = React.memo(({ url }: MapProps) => {
  return (
    <div
      className={styles.mapContainer}
      dangerouslySetInnerHTML={{
        __html: url || "",
      }}
    />
  );
});

export default Map;
